import type {
    IdentityPersistenceCollectionDefinition,
    PersistenceCollection
} from '@tadpoles/persistence'
import { ReadyRosieVideo } from '@tadpoles/common'

type LibraryVideoCollection = PersistenceCollection<ReadyRosieVideo, 'id'>

export type LibraryVideoPersistenceCollection = Pick<
    LibraryVideoCollection,
    'bulkPut' | 'findAll' | 'remove'
>

export const LibraryVideoCollectionDefinition: IdentityPersistenceCollectionDefinition<
    typeof ReadyRosieVideo,
    'id'
> = {
    kind: 'library-video',
    scope: 'global',
    primaryKey: 'id',
    modelSchema: ReadyRosieVideo
}

export class FamilyLibraryVideoStore {
    readonly #collection: LibraryVideoPersistenceCollection

    public constructor(collection: LibraryVideoPersistenceCollection) {
        this.#collection = collection
    }

    public async load(signal: AbortSignal): Promise<ReadyRosieVideo[]> {
        signal.throwIfAborted()
        const videos = await this.#collection.findAll()
        signal.throwIfAborted()
        return videos
    }

    public async replaceAll(videos: ReadyRosieVideo[], signal: AbortSignal): Promise<void> {
        signal.throwIfAborted()
        const existing = await this.#collection.findAll()
        await Promise.all(
            existing.map(async (video) => {
                await this.#collection.remove(video.id)
            })
        )
        await this.#collection.bulkPut(videos)
    }
}
